import { Grid, Typography } from '@mui/material'
import Image from 'next/image'
import React from 'react'
import { ButtonComponent } from 'src/components/shared/atoms'
import { DonateSkillContent } from 'src/types/components/shared/atom'
import useStyles from './Style'

interface IProps {
  zenMode: boolean
  content: DonateSkillContent
}
const DonateSkill: React.FC<IProps> = ({ zenMode, content }) => {
  const { heading, secondaryHeading, text, btn, img } = content
  const { classes } = useStyles()

  const handleClickScroll = () => {
    const element = document.getElementById('donate_skill_form')
    if (element) {
      // 👇 Will scroll smoothly to the top of the next section
      element.scrollIntoView({ behavior: 'smooth' })
    }
  }

  return (
    <Grid
      container
      justifyContent="space-between"
      className={classes.rootContainer}
    >
      <Grid item md={6} sm={6} xs={12} sx={{ order: { md: 1, sm: 1, xs: 2 } }}>
        <Grid className={classes.textContainer}>
          <Typography className={classes.heading}> {heading}</Typography>
          <Typography className={classes.secondaryHeading}>
            {secondaryHeading}
          </Typography>
          <Typography className={classes.text}> {text}</Typography>
          <ButtonComponent
            className={classes.btn}
            type="text"
            text={btn.content}
            gradient
            wrapperClass={classes.wrapper}
            onClick={handleClickScroll}
          />
        </Grid>
      </Grid>
      <Grid
        item
        container
        justifyContent="flex-end"
        md={6}
        sm={6}
        xs={12}
        sx={{
          order: { md: 2, sm: 2, xs: 1 },
          display: zenMode ? 'none' : 'flex',
        }}
      >
        <Grid className={classes.imgContainer}>
          <Image alt={heading} src={img} fill />
        </Grid>
      </Grid>
    </Grid>
  )
}

export default DonateSkill
